import {connect} from '../../app/connect';
import TemplatePreviewModal from './TemplatePreviewModal';
import {showNotificationAction, fetchIssueTemplateInstanceAction} from '../../app/actions';
import {getPendingTemplateForm, getCurrentPreviewTemplateId, getTemplateEntitiesMap} from '../../app/selectors';
import {actions as formActions} from 'react-redux-form';

const mapStateToProps = state => {
  const previewTemplateId = getCurrentPreviewTemplateId(state);
  return {
    previewTemplateId,
    previewTemplate: getTemplateEntitiesMap(state)[previewTemplateId],
    pendingTemplateForm: getPendingTemplateForm(state)
  };
};

const mapDispatchToProps = {
  showNotificationAction,
  fetchIssueTemplateInstanceAction,
  loadTemplateToForm: formActions.load
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatePreviewModal);
